/* eslint-disable jsx-a11y/accessible-emoji */
import React, { Component } from "react";
import { Link, withRouter } from 'react-router-dom';
import { createApiInstance, API_ENDPOINTS } from '../../../config/api';
import { setPageMeta } from "../../../utils/setPageMeta";
import ReactLoading from 'react-loading';
import {
  getCategory,
  getMentorView,
  getDomainCounts,
  getCollegeTypeCounts,
  COLLEGE_TYPE_ORDER,
  CATEGORY_META,
  goToBooking,
} from '../mentorProfile';
import './MentorLists.css';

class MentorLists extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mentors: [],
      loading: true,
      error: false,
      activeCategory: 'ALL',
      search: '',
      selectedColleges: new Set(),
      sort: 'newest',
      page: 1,
      perPage: 12,
    };
  }

  componentDidMount() {
    setPageMeta(
      "Find JEE & NEET Mentors from IIT, AIIMS | MentoMEET",
      "Browse verified mentors from IIT, AIIMS, NIT & top medical colleges. Get 1-on-1 guidance for JEE, NEET and Career. Book a session from ₹249."
    );
    this.syncCategoryFromRoute();
    this.fetchMentors();
  }

  componentDidUpdate(prevProps) {
    const prev = prevProps.match.params.category;
    const next = this.props.match.params.category;
    if (prev !== next) this.syncCategoryFromRoute();
  }

  syncCategoryFromRoute() {
    const cat = (this.props.match.params.category || 'ALL').toUpperCase();
    this.setState({ activeCategory: cat, page: 1 });
  }

  fetchMentors = async () => {
    try {
      const api = createApiInstance();
      const response = await api.get(API_ENDPOINTS.ALL_MENTORS);
      this.setState({
        mentors: response.data || [],
        loading: false,
      });
    } catch (error) {
      console.error('Error fetching mentors:', error);
      this.setState({ loading: false, error: true });
    }
  };

  setCategory = (category) => {
    const c = category.toUpperCase();
    const path = c === 'ALL' ? '/mentors' : `/mentors/${c.toLowerCase()}`;
    this.props.history.push(path);
  };

  toggleCollege = (type) => {
    this.setState(prev => {
      const set = new Set(prev.selectedColleges);
      if (set.has(type)) set.delete(type); else set.add(type);
      return { selectedColleges: set, page: 1 };
    });
  };

  setSort = (sort) => this.setState({ sort, page: 1 });

  setSearch = (e) => this.setState({ search: e.target.value, page: 1 });

  goToPage = (page) => this.setState({ page });

  getFiltered() {
    let list = this.state.mentors;

    if (this.state.activeCategory !== 'ALL') {
      list = list.filter(m => getCategory(m) === this.state.activeCategory);
    }

    if (this.state.selectedColleges.size > 0) {
      list = list.filter(m => this.state.selectedColleges.has(m.history?.[0]?.college_type || 'OTHER'));
    }

    if (this.state.search.trim()) {
      const q = this.state.search.toLowerCase();
      list = list.filter(m =>
        `${m.firstName} ${m.lastName}`.toLowerCase().includes(q) ||
        (m.history?.[0]?.college || '').toLowerCase().includes(q) ||
        getMentorView(m).expertise.some(e => e.toLowerCase().includes(q)) ||
        getCategory(m).toLowerCase().includes(q)
      );
    }

    if (this.state.sort === 'newest') {
      list = [...list]; // keep API order
    } else if (this.state.sort === 'rating') {
      list = [...list].sort((a, b) => parseFloat(getMentorView(b).rating) - parseFloat(getMentorView(a).rating));
    } else if (this.state.sort === 'name') {
      list = [...list].sort((a, b) => `${a.firstName} ${a.lastName}`.localeCompare(`${b.firstName} ${b.lastName}`));
    }

    return list;
  }

  getCategories() {
    const all = ['ALL', 'JEE', 'NEET', 'CAREER', 'DEVELOPMENT'];
    const counts = getDomainCounts(this.state.mentors);
    return all.filter(c => c === 'ALL' || counts[c] > 0).map(c => ({ key: c, label: c === 'ALL' ? 'All' : (CATEGORY_META[c]?.label || c) }));
  }

  getCollegeTypes() {
    const counts = getCollegeTypeCounts(this.getFilteredForCounts());
    return COLLEGE_TYPE_ORDER.filter(t => counts[t] > 0).map(t => ({ type: t, count: counts[t] }));
  }

  getFilteredForCounts() {
    let list = this.state.mentors;
    if (this.state.activeCategory !== 'ALL') {
      list = list.filter(m => getCategory(m) === this.state.activeCategory);
    }
    if (this.state.search.trim()) {
      const q = this.state.search.toLowerCase();
      list = list.filter(m =>
        `${m.firstName} ${m.lastName}`.toLowerCase().includes(q) ||
        (m.history?.[0]?.college || '').toLowerCase().includes(q) ||
        getMentorView(m).expertise.some(e => e.toLowerCase().includes(q)) ||
        getCategory(m).toLowerCase().includes(q)
      );
    }
    return list;
  }

  clearFilters = () => this.setState({ selectedColleges: new Set(), search: '', page: 1 });

  renderStarRow(rating) {
    const r = Math.round(parseFloat(rating));
    return '★'.repeat(r) + '☆'.repeat(5 - r);
  }

  renderCard(m) {
    const v = getMentorView(m);
    const photoStyle = v.photo
      ? { backgroundImage: `url(${v.photo})` }
      : { background: v.gradient };

    return (
      <article className="mm-mc" key={m._id} role="listitem" onClick={() => this.props.history.push(`/profile/${m._id}`)}>
        <div className="mm-mc-body">
          <div className="mm-mc-ring-wrap">
            <div className="mm-mc-ring">
              <div className="mm-mc-photo" style={photoStyle}>{!v.photo && v.initials}</div>
            </div>
          </div>
          <span className={`mm-mc-badge ${v.catMeta.badgeClass}`}>{v.catMeta.icon} {v.catMeta.label}</span>
          <div className="mm-mc-name">{v.fullName}</div>
          <div className="mm-mc-college">{v.college}</div>
          <div className="mm-mc-subject">{v.subject}</div>
          <div className="mm-mc-rat">
            <span className="mm-mc-stars">{this.renderStarRow(v.rating)}</span>
            <span className="mm-mc-rnum">{v.rating}</span>
          </div>
          <div className="mm-mc-tags">
            {v.expertise.slice(0, 3).map((t, i) => (
              <span className="mm-mc-tag" key={i}>{t}</span>
            ))}
          </div>
        </div>
        <div className="mm-mc-foot">
          <div className="mm-mc-price">₹{v.price} <sub>/session</sub></div>
          <div className="mm-mc-btns">
            <button className="mm-btn-c" onClick={(e) => goToBooking(e)}>Chat</button>
            <button className="mm-btn-b" onClick={(e) => goToBooking(e)}>Book</button>
          </div>
        </div>
      </article>
    );
  }

  render() {
    const { loading, error, activeCategory, search, selectedColleges, sort, page, perPage } = this.state;

    if (loading) {
      return (
        <div className="mm">
          <ReactLoading style={{ color: "black", margin: "auto", height: "15%", width: "15%" }} type={"spinningBubbles"} />
        </div>
      );
    }

    if (error) {
      return (
        <div className="mm mm-empty">
          <h4>Could not load mentors</h4>
          <p>Please check your connection and try again.</p>
        </div>
      );
    }

    const filtered = this.getFiltered();
    const total = filtered.length;
    const totalPages = Math.ceil(total / perPage) || 1;
    const start = (page - 1) * perPage;
    const pageItems = filtered.slice(start, start + perPage);
    const categories = this.getCategories();
    const collegeTypes = this.getCollegeTypes();
    const featured = this.state.mentors.slice(0, 4);

    return (
      <div className="mm">
        <section className="mm-hero" aria-label="Find your mentor">
          <div className="mm-hg" />
          <div className="mm-hgl1" />
          <div className="mm-hgl2" />
          <div className="mm-hero-inner">
            <div className="mm-hero-left">
              <div className="mm-hero-eyebrow"><span className="mm-he-dot" /> {this.state.mentors.length}+ verified mentors</div>
              <h1>Find a mentor who<br /><em>actually cracked it.</em></h1>
              <p className="mm-hero-sub">Not a coaching teacher. A real IIT, AIIMS or NIT topper who sat in your exact seat — and found a way through. JEE · NEET · Career.</p>
              <div className="mm-hero-search" role="search">
                <span className="mm-hs-icon">🔍</span>
                <input
                  className="mm-hs-input"
                  type="search"
                  placeholder="Search by name, college, exam or expertise..."
                  aria-label="Search mentors"
                  value={search}
                  onChange={this.setSearch}
                />
              </div>
              <div className="mm-hero-trust">
                <span className="mm-ht-item">Free to start</span>
                <span className="mm-ht-item">Sessions from ₹249</span>
                <span className="mm-ht-item">7-day money-back</span>
                <span className="mm-ht-item">Cancel anytime</span>
              </div>
            </div>

            {featured.length > 0 && (
              <div className="mm-hero-right">
                <div className="mm-proof-panel">
                  <div className="mm-pp-title">Featured mentors</div>
                  <div className="mm-pp-mentors">
                    {featured.map(m => {
                      const v = getMentorView(m);
                      const ps = v.photo ? { backgroundImage: `url(${v.photo})` } : { background: v.gradient };
                      return (
                        <div className="mm-pp-mentor" key={m._id} onClick={() => this.props.history.push(`/profile/${m._id}`)}>
                          <div className="mm-pp-av" style={ps}>{!v.photo && v.initials}</div>
                          <div className="mm-pp-info">
                            <div className="mm-pp-name">{v.fullName}</div>
                            <div className="mm-pp-college">{v.college} · {v.catMeta.label}</div>
                          </div>
                          <div className="mm-pp-right">
                            <div className="mm-pp-rating">★ {v.rating}</div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  <div className="mm-pp-stats">
                    <div className="mm-pp-stat"><div className="mm-pp-snum">{this.state.mentors.length}+</div><div className="mm-pp-slbl">Mentors</div></div>
                    <div className="mm-pp-stat"><div className="mm-pp-snum">₹249</div><div className="mm-pp-slbl">1st session</div></div>
                    <div className="mm-pp-stat"><div className="mm-pp-snum">100%</div><div className="mm-pp-slbl">Verified</div></div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </section>

        <div className="mm-domain-bar" role="navigation" aria-label="Filter by domain">
          <div className="mm-domain-inner">
            {categories.map(c => (
              <button
                key={c.key}
                className={`mm-dtab ${activeCategory === c.key ? 'mm-dtab-on' : ''}`}
                aria-pressed={activeCategory === c.key}
                onClick={() => this.setCategory(c.key)}
              >
                {c.label} <span className="mm-dtab-count">{getDomainCounts(this.state.mentors)[c.key] || 0}</span>
              </button>
            ))}
          </div>
        </div>

        <div className="mm-page-body">
          <aside className="mm-sidebar" aria-label="Filter mentors">
            <div className="mm-sb-head">
              <div className="mm-sb-htitle">🎛 Filters</div>
              <button className="mm-sb-reset" onClick={this.clearFilters}>Clear all</button>
            </div>
            <div className="mm-sb-sec">
              <div className="mm-sb-st">Exam / Domain</div>
              <div className="mm-sb-opts">
                {categories.filter(c => c.key !== 'ALL').map(c => {
                  const checked = activeCategory === c.key;
                  return (
                    <label className="mm-sb-opt" key={c.key}>
                      <input type="radio" name="domain" checked={checked} onChange={() => this.setCategory(c.key)} />
                      <span className="mm-sb-ol">{c.label}</span>
                      <span className="mm-sb-oc">{getDomainCounts(this.state.mentors)[c.key] || 0}</span>
                    </label>
                  );
                })}
              </div>
            </div>
            <div className="mm-sb-sec">
              <div className="mm-sb-st">College type</div>
              <div className="mm-sb-opts">
                {collegeTypes.map(({ type, count }) => (
                  <label className="mm-sb-opt" key={type}>
                    <input type="checkbox" checked={selectedColleges.has(type)} onChange={() => this.toggleCollege(type)} />
                    <span className="mm-sb-ol">{type}</span>
                    <span className="mm-sb-oc">{count}</span>
                  </label>
                ))}
              </div>
            </div>
          </aside>

          <main className="mm-results" role="main" aria-label="Mentor listings">
            <div className="mm-chips-row" role="group" aria-label="Quick filters">
              <button className={`mm-chip ${selectedColleges.size === 0 ? 'mm-chip-on' : ''}`} onClick={() => this.setState({ selectedColleges: new Set(), page: 1 })}>All mentors</button>
              <button className={`mm-chip ${sort === 'rating' ? 'mm-chip-on' : ''}`} onClick={() => this.setSort(sort === 'rating' ? 'newest' : 'rating')}>⭐ Top rated</button>
              <button className={`mm-chip ${sort === 'newest' && this.getFiltered().length === this.state.mentors.length ? '' : (sort === 'newest' ? 'mm-chip-on' : '')}`} onClick={() => this.setSort('newest')}>🆕 New mentors</button>
              {['IIT', 'AIIMS', 'NIT'].map(t => (
                <button
                  key={t}
                  className={`mm-chip ${selectedColleges.has(t) ? 'mm-chip-on' : ''}`}
                  onClick={() => this.toggleCollege(t)}
                >
                  {t}
                </button>
              ))}
            </div>

            <div className="mm-results-bar">
              <div className="mm-rb-count">
                Showing <span>{total}</span> {activeCategory === 'ALL' ? 'mentors' : activeCategory.toLowerCase() + ' mentors'}
              </div>
              <div className="mm-rb-right">
                <select className="mm-sort-sel" aria-label="Sort mentors" value={sort} onChange={(e) => this.setSort(e.target.value)}>
                  <option value="newest">Newest joined</option>
                  <option value="rating">Highest rated</option>
                  <option value="name">Name A–Z</option>
                </select>
              </div>
            </div>

            <section className="mm-mgrid" role="list" aria-label="Mentor cards">
              <h2 className="mm-sr-only">Mentors matching your filters</h2>
              {pageItems.length > 0 ? (
                pageItems.map(m => this.renderCard(m))
              ) : (
                <div className="mm-no-results">
                  <h3>No mentors found</h3>
                  <p>Try a different search or filter.</p>
                </div>
              )}
            </section>

            {totalPages > 1 && (
              <nav className="mm-pag" aria-label="Pagination">
                <button className="mm-pg" onClick={() => this.goToPage(Math.max(1, page - 1))} disabled={page === 1} aria-label="Previous page">‹</button>
                {Array.from({ length: totalPages }, (_, i) => i + 1)
                  .filter(p => p === 1 || p === totalPages || Math.abs(p - page) <= 1)
                  .map((p, idx, arr) => (
                    <React.Fragment key={p}>
                      {idx > 0 && arr[idx - 1] !== p - 1 && <span className="mm-pg-dots">···</span>}
                      <button
                        className={`mm-pg ${p === page ? 'mm-pg-on' : ''}`}
                        onClick={() => this.goToPage(p)}
                        aria-current={p === page ? 'page' : undefined}
                        aria-label={`Page ${p}`}
                      >
                        {p}
                      </button>
                    </React.Fragment>
                  ))}
                <button className="mm-pg" onClick={() => this.goToPage(Math.min(totalPages, page + 1))} disabled={page === totalPages} aria-label="Next page">›</button>
              </nav>
            )}
          </main>
        </div>

        <section className="mm-conv-strip" aria-label="Get started with MentoMEET">
          <div style={{ position: 'relative', zIndex: 1 }}>
            <div className="mm-cs-eyebrow">Not sure where to start?</div>
            <div className="mm-cs-title">Try one session for <em>₹249.</em></div>
            <p className="mm-cs-sub">No subscription. No pressure. 60 minutes with a real topper can reset your entire preparation.</p>
            <div className="mm-cs-btns">
              <button className="mm-cs-primary" onClick={() => goToBooking()}>Book a session — ₹249 →</button>
              <Link to="/mentors" className="mm-cs-secondary">Browse all mentors</Link>
            </div>
            <div className="mm-cs-trust">
              <span className="mm-cs-ti">No auto-renewal</span>
              <span className="mm-cs-ti">7-day money-back</span>
              <span className="mm-cs-ti">Secure via Razorpay</span>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default withRouter(MentorLists);

